import type { AppUpsellEntryPoint } from '@/config/app-upsells';
import type { EventDefinition } from './navigation';

export type AppUpsellSurface = 'feed' | 'navigation' | 'dialog';
export type AppUpsellProperties = {
  surface: AppUpsellSurface;
  entry_point: AppUpsellEntryPoint;
  campaign: 'app_launch';
  creative: 'light_card_feed' | 'dark_card_feed' | 'app_navigation' | 'pocket_dialog';
  device: 'iphone' | 'android' | 'tablet' | 'desktop';
};
export type AppUpsellClickedProperties = AppUpsellProperties & {
  destination: 'app_store' | 'dialog';
};

export const APP_UPSELL_VIEWED: EventDefinition<AppUpsellProperties> = {
  name: 'app_upsell_viewed',
};
export const APP_UPSELL_CLICKED: EventDefinition<AppUpsellClickedProperties> = {
  name: 'app_upsell_clicked',
};
export const APP_UPSELL_DISMISSED: EventDefinition<AppUpsellProperties> = {
  name: 'app_upsell_dismissed',
};
